"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLinePax = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLinePax = (item) => {
    if (!item.versions)
        return 0;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    if (!latest_version)
        return 0;
    switch (item.type) {
        case "GOLF": {
            const config = latest_version.config;
            return config.where_when_who?.number_of_golfers || 0;
        }
        case "HOTEL": {
            const config = latest_version.config;
            return config?.where_when_who?.number_of_guests || 0;
        }
        case "TRANSFER": {
            const config = latest_version.config;
            return config?.where_when_who?.number_of_passengers || 0;
        }
        case "EXCURSION": {
            const config = latest_version.config;
            return config?.where_when_who?.number_of_people || 0;
        }
        case "CUSTOM": {
            const config = latest_version.config;
            return config?.where_when_who?.pax || 0;
        }
        default:
            return 0;
    }
};
exports.getOrderLinePax = getOrderLinePax;
